module.exports = __webpack_public_path__ + "static/media/Light_Shine.73636386.png";